import React from "react";
import { Modal, Space, Pagination } from "antd";

export default function SerialsModal({
  visible,
  onClose,
  serialsList,
  serialsPage,
  pageSize,
  serialsTotal,
  onPageChange,
}) {
  const serialsPerRow = 6;
  const serialsRows = [];
  for (let i = 0; i < serialsList.length; i += serialsPerRow) {
    serialsRows.push(serialsList.slice(i, i + serialsPerRow));
  }
  return (
    <Modal
      width={800}
      title="Serials"
      open={visible}
      onOk={onClose}
      onCancel={onClose}
    >
      {serialsRows.map((row, idx) => (
        <Space key={idx} style={{ marginBottom: 8 }}>
          {row.map((serial) => (
            <span
              key={serial.id}
              style={{
                display: "inline-block",
                minWidth: 90,
                padding: "4px 8px",
                background: "#f5f5f5",
                borderRadius: 4,
                textAlign: "center",
                fontFamily: "monospace",
              }}
            >
              {serial.serial}
            </span>
          ))}
        </Space>
      ))}
      <Pagination
        current={serialsPage}
        pageSize={pageSize}
        total={serialsTotal}
        onChange={onPageChange}
        style={{ marginTop: 16, textAlign: "center" }}
      />
    </Modal>
  );
} 